// Mapper: transporte LC_ListMonitoringAbsenteesOut → dominio MonitoringAbsenteesPage.
// Mantiene la UI desacoplada del DTO de la API y normaliza los valores ausentes.

import type {
  LC_MonitoringAbsenteeItem,
  LC_ListMonitoringAbsenteesOut,
  MonitoringAbsentee,
  MonitoringAbsenteesPage,
} from '../types/monitoringAbsentees.types';


export function mapMonitoringAbsentee(item: LC_MonitoringAbsenteeItem): MonitoringAbsentee {
  return {
    rut: item.employeeTaxIdentificationNumber ?? '',
    fullName: item.fullName ?? '',
    statusCode: item.statusCode ?? '',
  };
}

export function mapMonitoringAbsenteesPage(
  out: LC_ListMonitoringAbsenteesOut,
): MonitoringAbsenteesPage {
  return {
    items: (out.items ?? []).map(mapMonitoringAbsentee),
    totalRecords: out.pagination?.totalRecords ?? 0,
  };
}
